var styles = {"caption":"styles_caption__UPq01 p2 flex","curation-icon":"styles_curation-icon__1OC6w mr1","curationIcon":"styles_curation-icon__1OC6w mr1","category-icon":"styles_category-icon__2vNE2","categoryIcon":"styles_category-icon__2vNE2","break":"styles_break__2LpLa mb2"};

export default styles;
//# sourceMappingURL=styles.css.js.map
